var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center",class:_vm.getClassBasedOnBreakpoint},[_c('v-img',{attrs:{"src":require("../assets/icons/logo.svg"),"max-width":"30vw","max-height":"30vw"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }